var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.00001C9 7.18571 8.91683 7.34386 8.76655 7.48351L1.5025 13.8064C1.36749 13.9355 1.18424 14 0.977711 14C0.567429 14 0.25 13.7199 0.25 13.3431C0.25 13.1599 0.329553 13.0018 0.460956 12.8759L7.20663 7.00001L0.460956 1.1241C0.329553 0.998227 0.25 0.832822 0.25 0.656899C0.25 0.280026 0.567429 0 0.977711 0C1.18424 0 1.36749 0.0645648 1.5025 0.193694L8.76655 6.51651C8.91683 6.65615 9 6.8143 9 7.00001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArr);
export default __webpack_public_path__ + "static/media/right-arr.4e4d2ee9d3094c0aa0d9487e7393579a.svg";
export { ForwardRef as ReactComponent };